import React from 'react';
import {Paper, Table, TableBody, TableRow, TableRowColumn} from 'material-ui';
import {observer, inject} from 'mobx-react';
import {cmURL} from '../libs/config'
import TextTruncate from './common/TextTruncate';

@inject('contentStore')
@observer
class Projects extends React.Component {

    pdfTable = [
        {name:'Irrigation and Water Resources Management Project - Telemetry Component', url:'http://hydrology.gov.np/new/hydrology/_files/90c300fd2cd7534c73cba15a89d4b73b.pdf'},
        {name:'Establishment of a regional flood information system in the HKH-region (HKH-HYCOS)', url:'http://hydrology.gov.np/new/hydrology/_files/636ff5c5343a60062d001529ee6c9f15.pdf'}
    ];

    render() {
      let projects = this.props.contentStore.projects;
      return(
        <div className="inline-it">
          <Paper zDepth={2}>
            <Table style={{maxWidth:'1000px'}}>
              <TableBody displayRowCheckbox={false} showRowHover={false} stripedRows={true}>{
                projects.length>0 && projects.map((item, index) => (
                  <TableRow selectable={false} key={index}>
                    <TableRowColumn style={{paddingTop:item.description==='5px'?'':'10px', whiteSpace:'normal'}}>
                      <a href={`${cmURL}/files/${item.file_name}`} target="_blank" rel="noopener noreferrer" className="content-title">{item.title}</a>
                      <TextTruncate text={item.description}/>
                    </TableRowColumn>
                  </TableRow>
                ))
              }</TableBody>
            </Table>
          </Paper>
        </div>
      );
    }
}

export default Projects;


// WEBPACK FOOTER //
// ./src/components/Projects.js